import _ from 'lodash';
import {
    SET_IS_LOADING,
    OPEN_LEGEND,
    CLOSE_LEGEND,
    SET_PEN,
} from '../actions/actionCreators/staticPen';

const initialState = {
    isLoading: true,
    isLegendOpen: false,
    pen: {},
};

export default function staticPen(state = initialState, action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case SET_IS_LOADING:
            newState.isLoading = action.isLoading;
            return newState;
        case OPEN_LEGEND:
            newState.isLegendOpen = true;
            return newState;
        case CLOSE_LEGEND:
            newState.isLegendOpen = false;
            return newState;
        case SET_PEN:
            newState.pen = action.pen;
            return newState;
        default:
            return state;
    }
}
